import { isEqual } from "lib/isEqual"
import { buildDraftSnapshot } from "authoring/routes/project/schedule-editor/lib/build-draft-snapshot"
import { normalizeScheduleToMacroIds } from "authoring/routes/macro/lib/macro-conversion"
import { prepareScheduleForAuthoringComparison } from "authoring/routes/project/schedule-editor/lib/prepare-schedule-for-authoring-comparison"
import { getBrowserAuthoringNormalizers } from "authoring/routes/project/schedule-editor/lib/browser-authoring-normalizers"
import { memoizeNormalizer } from "authoring/routes/project/schedule-editor/lib/memoized-normalization"

/**
 * @param {object} params
 * @param {object} [params.draft]
 * @param {object} [params.compareSource]
 * @param {boolean} [params.compareLoading]
 * @param {boolean} [params.dirty]
 * @param {object} [params.macroMap]
 * @param {ReturnType<typeof getBrowserAuthoringNormalizers>} [params.normalizers]
 * @returns {boolean | null}
 */
export function resolveHasCompareChanges({
    draft,
    compareSource,
    compareLoading = false,
    dirty = false,
    macroMap,
    normalizers = getBrowserAuthoringNormalizers(),
}) {
    if (compareLoading || !draft || !compareSource || dirty) return null

    const normalizeSnapshotHtml = memoizeNormalizer(normalizers.normalizeAuthoringSnapshotHtml)
    const normalizedDraft = prepareScheduleForAuthoringComparison(
        normalizeScheduleToMacroIds(draft, macroMap),
        normalizers
    )
    const normalizedSource = prepareScheduleForAuthoringComparison(
        normalizeScheduleToMacroIds(compareSource, macroMap),
        normalizers
    )
    const draftSnapshot = buildDraftSnapshot({
        draft: normalizedDraft,
        normalizeHtml: true,
        normalizeSnapshotHtml,
    })
    const sourceSnapshot = buildDraftSnapshot({
        draft: normalizedSource,
        normalizeHtml: true,
        normalizeSnapshotHtml,
    })

    if (!draftSnapshot || !sourceSnapshot) return null

    return !isEqual(draftSnapshot, sourceSnapshot)
}
